// Bridge between data-access (a plain module) and the app's global modal state.
//
// The server refuses a delete with 409 when other resources still reference the target. Rather than
// making every one of the hundreds of delete call sites handle that, handleResponse notifies here
// and the React root subscribes once.
//
// Mirrors the listener registry in strings/locale.js - no window globals, no event bus.

/** Discriminator sent by the server on the 409 body. */
export const DeleteBlockedCode = "ResourceInUse";

const listeners = new Set();

/** Subscribe to blocked-delete responses. Returns an unsubscribe function. */
export function onDeleteBlocked(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

/**
 * Notify subscribers that a delete was refused. No-ops when nothing is subscribed, so non-UI
 * consumers of data-access (and tests) are unaffected.
 */
export function notifyDeleteBlocked(blocked) {
    for (const listener of listeners) {
        try {
            listener(blocked);
        } catch (error) {
            // A failing listener must never break the fetch that triggered it.
            console.log(error);
        }
    }
    return listeners.size > 0;
}

/** True when a data-access result is a blocked-delete response. */
export function isDeleteBlocked(result) {
    return result?.status === 409 && !!result?.blocked;
}
